import { PropsWithChildren } from 'react';

import { usePreventScroll } from '@editor/hooks/usePreventScroll';
import { ScrollableArea } from '@repo/ui-kit/components/core/ScrollableArea';

import { FullScreenModal, SimpleSurveyContainer } from './styles';

const OnboardingSurveyScreen: React.FC<PropsWithChildren> = ({ children }) => {
  usePreventScroll();

  return (
    <FullScreenModal>
      <ScrollableArea>
        <SimpleSurveyContainer alignItems="center">
          {children}
        </SimpleSurveyContainer>
      </ScrollableArea>
    </FullScreenModal>
  );
};

export default OnboardingSurveyScreen;
